/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Pnk_Tea_Purchase_SearchInputs */

const vi_pl_pnk_tea_purchase_search = /** @type {(inputs: Pl_Pnk_Tea_Purchase_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm đơn mua...`)
};

/**

* @param {Pl_Pnk_Tea_Purchase_SearchInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_pnk_tea_purchase_search = /** @type {((inputs?: Pl_Pnk_Tea_Purchase_SearchInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Pnk_Tea_Purchase_SearchInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_pnk_tea_purchase_search(inputs)
});